export default "__VITE_ASSET__DdPVRzZ5__"